export const iconFontAwesomeAlertQuestion = (
	<i className="fa-solid fa-question"></i>
);
